import React, { useState } from 'react';
import { createCtx } from '../utils/helpers';

export type Lawyer<T extends string = string> = {
  fullName: T;
  phone1: T;
  phone2: T;
  email: T;
  address: T;
  experienceYears: T;
  telegramLink: T;
  whatsAppLink: T;
  viberLink: T;
};

const [useLawyerContext, LawyerContextProvider] = createCtx<Lawyer>();

export { useLawyerContext };

export function LawyerProvider({
  children,
}: React.PropsWithChildren<unknown>): JSX.Element {
  const [lawyer] = useState<Lawyer>({
    fullName: 'lawyer.fullName',
    phone1: 'lawyer.phone1',
    phone2: 'lawyer.phone2',
    email: 'lawyer.email',
    address: 'lawyer.address',
    experienceYears: 'lawyer.experienceYears',
    telegramLink: 'https://t.me/Khachaturov_R',
    whatsAppLink: 'https://wa.me/380509149176',
    viberLink: 'viber://chat?number=%2B380509149176',
  });

  return <LawyerContextProvider value={lawyer}>{children}</LawyerContextProvider>;
}
